import { render } from "./HomePricing.vue?vue&type=template&id=96da1a52"
import script from "./HomePricing.vue?vue&type=script&lang=js"
export * from "./HomePricing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__